import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "assistant-window__header" }
const _hoisted_2 = { class: "assistant-window__identity" }
const _hoisted_3 = {
  class: "assistant-window__badge",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "assistant-window__titles" }
const _hoisted_5 = { class: "assistant-window__status" }
const _hoisted_6 = { class: "assistant-window__tools" }
const _hoisted_7 = ["aria-pressed", "title", "aria-label"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["title", "aria-label"]
const _hoisted_10 = { class: "assistant-window__main" }

import { computed, watch } from "vue";
import { Icon } from "@/components/ui";
import AgentConversationList from "@/components/agent/AgentConversationList.vue";
import AssistantChat from "@/components/agent/assistant/AssistantChat.vue";
import { useAssistantChat } from "@/composables/agent/useAssistantChat";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssistantWindow',
  props: {
    expanded: { type: Boolean }
  },
  emits: ["close", "toggle-expand"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { conversationId, isSending, isThreadWorking, isLoadingThread, open, reset, showHistory } =
  useAssistantChat();

// The docked panel is narrow, so past chats take its place instead of sitting beside it.
// Shared, so the bubble can open straight onto the list when several replies came in.
watch(
  () => props.expanded,
  () => (showHistory.value = false)
);

const statusText = computed(() => {
  if (isSending.value) return "Thinking…";
  if (isThreadWorking.value) return "Still working…";
  if (isLoadingThread.value) return "Loading…";
  return "Drafts wait for your approval";
});

const selectThread = (id: string) => {
  open(id);
  showHistory.value = false;
};

const startNew = () => {
  reset();
  showHistory.value = false;
};

const onDeleted = (id: string) => {
  if (id === conversationId.value) reset();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["assistant-window", { 'assistant-window--expanded': __props.expanded }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_unref(Icon), { icon: "mdi:creation" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "assistant-window__title" }, "CRM Assistant", -1)),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["assistant-window__dot", { 'assistant-window__dot--busy': _unref(isSending) || _unref(isThreadWorking) }])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(statusText.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!__props.expanded)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(["assistant-window__tool", { 'assistant-window__tool--active': _unref(showHistory) }]),
              "aria-pressed": _unref(showHistory),
              title: _unref(showHistory) ? 'Back to chat' : 'Past chats',
              "aria-label": _unref(showHistory) ? 'Back to chat' : 'Past chats',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showHistory.value = !_unref(showHistory)))
            }, [
              _createVNode(_unref(Icon), {
                icon: _unref(showHistory) ? 'mdi:message-text-outline' : 'mdi:history'
              }, null, 8, ["icon"])
            ], 10, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "assistant-window__tool",
          title: "New chat",
          "aria-label": "New chat",
          disabled: _unref(isSending),
          onClick: startNew
        }, [
          _createVNode(_unref(Icon), { icon: "mdi:square-edit-outline" })
        ], 8, _hoisted_8),
        _createElementVNode("button", {
          type: "button",
          class: "assistant-window__tool",
          title: __props.expanded ? 'Shrink to panel' : 'Expand',
          "aria-label": __props.expanded ? 'Shrink to panel' : 'Expand',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggle-expand')))
        }, [
          _createVNode(_unref(Icon), {
            icon: __props.expanded ? 'mdi:arrow-collapse' : 'mdi:arrow-expand'
          }, null, 8, ["icon"])
        ], 8, _hoisted_9),
        _createElementVNode("button", {
          type: "button",
          class: "assistant-window__tool",
          title: "Close",
          "aria-label": "Close assistant",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, [
          _createVNode(_unref(Icon), { icon: "mdi:close" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (__props.expanded || _unref(showHistory))
        ? (_openBlock(), _createBlock(AgentConversationList, {
            key: 0,
            class: _normalizeClass(["assistant-window__threads", { 'assistant-window__threads--full': !__props.expanded }]),
            mode: "assistant",
            "active-id": _unref(conversationId),
            disabled: _unref(isSending),
            onSelect: selectThread,
            onNew: startNew,
            onDeleted: onDeleted
          }, null, 8, ["class", "active-id", "disabled"]))
        : _createCommentVNode("", true),
      (__props.expanded || !_unref(showHistory))
        ? (_openBlock(), _createBlock(AssistantChat, {
            key: 1,
            roomy: __props.expanded
          }, null, 8, ["roomy"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})